import clone from 'lodash/cloneDeep';
import {
  DEACTIVATE_GUSSET_END_PLATE_STARTING,
  DEACTIVATE_GUSSET_END_PLATE_SUCCESS,
  DEACTIVATE_GUSSET_END_PLATE_ERROR,
} from '../../../constants/actionTypes';
import initialState from '../../../store/initialState';

export default function deactivateGussetEndPlateReducer(state = initialState.deactivateGussetEndPlate, action) {
  switch (action.type) {
    case DEACTIVATE_GUSSET_END_PLATE_STARTING: {
      const { gussetEndPlateId } = action;
      const newState = clone(state);

      if (!newState[gussetEndPlateId]) {
        newState[gussetEndPlateId] = clone(initialState.deactivategussetEndPlate.gussetEndPlateId);
      }

      const gussetEndPlateData = newState[gussetEndPlateId];
      gussetEndPlateData.saving = true;
      gussetEndPlateData.saved = false;
      gussetEndPlateData.error = null;

      return newState;
    }

    case DEACTIVATE_GUSSET_END_PLATE_SUCCESS: {
      const { gussetEndPlateId } = action;
      const newState = clone(state);

      if (!newState[gussetEndPlateId]) {
        newState[gussetEndPlateId] = clone(initialState.deactivategussetEndPlate.gussetEndPlateId);
      }

      const gussetEndPlateData = newState[gussetEndPlateId];
      gussetEndPlateData.saving = false;
      gussetEndPlateData.saved = true;
      gussetEndPlateData.error = null;
      return newState;
    }

    case DEACTIVATE_GUSSET_END_PLATE_ERROR: {
      const { gussetEndPlateId } = action;
      const newState = clone(state);

      if (!newState[gussetEndPlateId]) {
        newState[gussetEndPlateId] = clone(initialState.deactivategussetEndPlate.gussetEndPlateId);
      }

      const gussetEndPlateData = newState[gussetEndPlateId];
      gussetEndPlateData.saving = false;
      gussetEndPlateData.saved = false;
      gussetEndPlateData.error = action.err;
      return newState;
    }

    default: {
      return state;
    }
  }
}
